<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NLSOI6/tc-custom/9781618687586.jpg?1737673518855" alt="This image is the cover for the book Highway, The Reanimates Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Highway, The Reanimates Series
      </h1>
      <p class="bookDescription body article font2">
        <b>Survivors of a zombie apocalypse flee their homes, but their journey to safety is riddled with terror in this chilling sequel to <i>The Complex</i>.</b><br/><br/>The Complex is in ruins. The zombies are everywhere.<br/><br/>Cali Anglin and the other survivors have one slim hope: sanctuary in Idaho, thousands of miles away. They must take to the Highway—Interstate 15, the only path to safety. Their trek across a devastated America is one horror stacked on another, constantly pursued by the hungry dead.<br/><br/>They must ask themselves: How much would you pay to begin again?<br/><br/><b>Praise for <i>The Complex</i></b><br/><br/><b>“I really enjoyed <i>The Complex</i>. . . . It brings a new and missing dynamic to the genre. . . . Ms. Rudolph tells a good story that left me wanting more.” —David Forsyth, author of the Sovereign Spirit Saga</b><br/><br/><b>“This is a fantastic read that I could not recommend more!” —Tony Baker, author of <i>Survivors of the Dead</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J. Rudolph
      </h2>
      
      <p class="authorDescription body article">J. Rudolph is the author of the zombie series The Reanimates, and the young adult paranormal mystery, Hadley's Haunting. Born in 1977, she resides in Southern California with her husband, son, two turtles (who she claims own all rights to her house and allow the people to live there, only since they can open the food jars) and her maniacal bird (who seems to have developed a taste for flesh in its lifetime). As a nurse with over fifteen years of experience, she often incorporates an element of medical training in her stories, offering authenticity to her medically minded characters. She also offers authenticity to her zombie series-she calls herself a living dead girl ever since her spinal reconstruction in 2014.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      J. Rudolph
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7c0d465f